(function() {
  'use strict';

  var JST_OFFSET_MS = 9 * 60 * 60 * 1000;
  var DAY_MS = 24 * 60 * 60 * 1000;
  var WEEK_MS = 7 * DAY_MS;
  var MAX_TIMEOUT_MS = 2147483647;
  var SECTION_SELECTOR = '[data-weekend-event-section]';
  var BLOCK_SELECTOR = '[data-weekend-event-block]';

  function parseClock(value) {
    var match = /^(\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;

    var hour = Number(match[1]);
    var minute = Number(match[2]);
    if (hour > 23 || minute > 59) return null;

    return { hour: hour, minute: minute };
  }

  function parseJstDateTime(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return null;

    var epoch = Date.UTC(year, month - 1, day, hour - 9, minute);
    var check = new Date(epoch + JST_OFFSET_MS);
    if (
      check.getUTCFullYear() !== year ||
      check.getUTCMonth() !== month - 1 ||
      check.getUTCDate() !== day ||
      check.getUTCHours() !== hour ||
      check.getUTCMinutes() !== minute
    ) {
      return null;
    }

    return epoch;
  }

  function getJstWeekPosition(nowMs) {
    var shifted = new Date(nowMs + JST_OFFSET_MS);
    return (
      shifted.getUTCDay() * DAY_MS +
      shifted.getUTCHours() * 60 * 60 * 1000 +
      shifted.getUTCMinutes() * 60 * 1000 +
      shifted.getUTCSeconds() * 1000 +
      shifted.getUTCMilliseconds()
    );
  }

  function nextWeeklyBoundary(nowMs, boundaryPosition) {
    var currentPosition = getJstWeekPosition(nowMs);
    var delta = boundaryPosition - currentPosition;
    if (delta <= 0) delta += WEEK_MS;
    return nowMs + delta;
  }

  function evaluateWeekly(block, nowMs) {
    var startClock = parseClock(block.dataset.weeklyStartTime);
    var endClock = parseClock(block.dataset.weeklyEndTime);
    var startDay = Number(block.dataset.weeklyStartDay);
    var endDay = Number(block.dataset.weeklyEndDay);

    if (
      !startClock ||
      !endClock ||
      !Number.isInteger(startDay) ||
      !Number.isInteger(endDay) ||
      startDay < 0 ||
      startDay > 6 ||
      endDay < 0 ||
      endDay > 6
    ) {
      return { active: false, nextBoundary: null };
    }

    var startPosition = startDay * DAY_MS + startClock.hour * 60 * 60 * 1000 + startClock.minute * 60 * 1000;
    var endPosition = endDay * DAY_MS + endClock.hour * 60 * 60 * 1000 + endClock.minute * 60 * 1000;
    if (startPosition === endPosition) return { active: false, nextBoundary: null };

    var currentPosition = getJstWeekPosition(nowMs);
    var active = startPosition < endPosition
      ? currentPosition >= startPosition && currentPosition < endPosition
      : currentPosition >= startPosition || currentPosition < endPosition;

    return {
      active: active,
      nextBoundary: Math.min(
        nextWeeklyBoundary(nowMs, startPosition),
        nextWeeklyBoundary(nowMs, endPosition)
      )
    };
  }

  function evaluateSpecific(block, nowMs) {
    var start = parseJstDateTime(block.dataset.specificStart);
    var end = parseJstDateTime(block.dataset.specificEnd);
    if (start === null || end === null || end <= start) {
      return { active: false, nextBoundary: null };
    }

    if (nowMs < start) return { active: false, nextBoundary: start };
    if (nowMs < end) return { active: true, nextBoundary: end };
    return { active: false, nextBoundary: null };
  }

  function evaluateBlock(block, nowMs) {
    if (block.dataset.eventEnabled !== 'true') return { active: false, nextBoundary: null };

    if (block.dataset.scheduleMode === 'always') return { active: true, nextBoundary: null };
    if (block.dataset.scheduleMode === 'weekly') return evaluateWeekly(block, nowMs);
    if (block.dataset.scheduleMode === 'specific') return evaluateSpecific(block, nowMs);
    return { active: false, nextBoundary: null };
  }

  function removeBottomNotice(section) {
    var owner = section.dataset.sectionId;
    document.querySelectorAll('[data-weekend-event-bottom-owner="' + owner + '"]').forEach(function(notice) {
      notice.remove();
    });
  }

  function renderBottomNotice(section, activeBlock) {
    removeBottomNotice(section);
    if (!activeBlock || section.dataset.showBottomNotice !== 'true') return;

    var target = document.querySelector(section.dataset.bottomTarget || '[data-weekend-event-bottom-target]');
    if (!target) return;

    var notice = document.createElement('aside');
    notice.className = 'weekend-event-notice__bottom';
    notice.dataset.weekendEventBottomOwner = section.dataset.sectionId;
    notice.setAttribute('aria-live', 'polite');

    var sectionStyles = window.getComputedStyle(section);
    [
      '--weekend-event-background',
      '--weekend-event-text',
      '--weekend-event-accent',
      '--weekend-event-button-background',
      '--weekend-event-button-text',
      '--weekend-event-radius',
      '--weekend-event-border-width',
      '--weekend-event-border'
    ].forEach(function(propertyName) {
      notice.style.setProperty(propertyName, sectionStyles.getPropertyValue(propertyName));
    });

    var title = document.createElement('p');
    title.className = 'weekend-event-notice__bottom-title';
    title.textContent = activeBlock.dataset.bottomTitle || '週末イベント開催中';
    notice.appendChild(title);

    if (activeBlock.dataset.bottomText) {
      var text = document.createElement('p');
      text.className = 'weekend-event-notice__bottom-text';
      text.textContent = activeBlock.dataset.bottomText;
      notice.appendChild(text);
    }

    target.appendChild(notice);
  }

  function setEditorBadge(block, visible) {
    var badge = block.querySelector('[data-weekend-event-editor-badge]');
    if (badge) badge.hidden = !visible;
  }

  function showOnly(section, block, editorPreview) {
    var blocks = Array.prototype.slice.call(section.querySelectorAll(BLOCK_SELECTOR));
    blocks.forEach(function(candidate) {
      candidate.hidden = candidate !== block;
      setEditorBadge(candidate, candidate === block && editorPreview);
    });
    section.hidden = !block;
    renderBottomNotice(section, editorPreview ? null : block);
  }

  function scheduleNextEvaluation(section, boundary, nowMs) {
    if (section.__weekendEventTimer) window.clearTimeout(section.__weekendEventTimer);
    section.__weekendEventTimer = null;
    if (boundary === null) return;

    var delay = Math.max(50, Math.min(boundary - nowMs + 50, MAX_TIMEOUT_MS));
    section.__weekendEventTimer = window.setTimeout(function() {
      evaluateSection(section);
    }, delay);
  }

  function evaluateSection(section) {
    var blocks = Array.prototype.slice.call(section.querySelectorAll(BLOCK_SELECTOR));
    var nowMs = Date.now();
    var enabled = section.dataset.sectionEnabled === 'true';
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    var allowEditorPreview = designMode && section.dataset.editorPreview === 'true';
    var activeBlock = null;
    var nextBoundary = null;

    blocks.forEach(function(block) {
      var result = evaluateBlock(block, nowMs);
      if (!activeBlock && result.active) activeBlock = block;
      if (result.nextBoundary !== null && (nextBoundary === null || result.nextBoundary < nextBoundary)) {
        nextBoundary = result.nextBoundary;
      }
    });

    if (section.__weekendEventSelectedBlock && section.contains(section.__weekendEventSelectedBlock)) {
      showOnly(section, section.__weekendEventSelectedBlock, true);
    } else if (enabled && activeBlock) {
      showOnly(section, activeBlock, false);
    } else if (allowEditorPreview) {
      showOnly(section, blocks.find(function(block) {
        return block.dataset.eventEnabled === 'true';
      }) || blocks[0] || null, true);
    } else {
      showOnly(section, null, false);
    }

    scheduleNextEvaluation(section, nextBoundary, nowMs);
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];
    if (scope.matches && scope.matches(SECTION_SELECTOR)) sections.push(scope);
    sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll(SECTION_SELECTOR)));
    sections.forEach(evaluateSection);
  }

  function handleBlockSelect(event) {
    var block = event.target.closest ? event.target.closest(BLOCK_SELECTOR) : null;
    if (!block) return;
    var section = block.closest(SECTION_SELECTOR);
    if (!section) return;
    section.__weekendEventSelectedBlock = block;
    evaluateSection(section);
  }

  function handleBlockDeselect(event) {
    var block = event.target.closest ? event.target.closest(BLOCK_SELECTOR) : null;
    if (!block) return;
    var section = block.closest(SECTION_SELECTOR);
    if (!section) return;
    section.__weekendEventSelectedBlock = null;
    evaluateSection(section);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initialize(document); });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', function(event) { initialize(event.target); });
    document.addEventListener('shopify:block:select', handleBlockSelect);
    document.addEventListener('shopify:block:deselect', handleBlockDeselect);
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) initialize(document);
    });
    window.addEventListener('pageshow', function() { initialize(document); });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      evaluateBlock: evaluateBlock,
      evaluateSpecific: evaluateSpecific,
      evaluateWeekly: evaluateWeekly,
      parseClock: parseClock,
      parseJstDateTime: parseJstDateTime
    };
  }
})();
